module.exports = __webpack_public_path__ + "static/media/IMG_0395.1ee75b6c.JPG";